import { BaseModel } from "../BaseModel";
import { BaseFindResult } from "../BaseFindResult";
import { SiteConfigModel } from "./SiteConfigModel";

export class SiteConfigFindResultModel extends BaseFindResult {

    public getDataItem(i: number): SiteConfigModel {
        let o: SiteConfigModel = Object.assign(new SiteConfigModel(), this.data[i]);
        return o;
    }

    public get dataTyped(): SiteConfigModel[] {

        let d: SiteConfigModel[] = [];

        for (var i = 0; i < this.data.length; i++) {
            d.push(this.getDataItem(i));
        }
        return d;
    }

    public override assignObjects(): void {
        super.assignObjects();

        for (var i = 0; i < this.data.length; i++) {
            let o: SiteConfigModel = Object.assign(new SiteConfigModel(), this.data[i]);
            this.data[i] = o;
        }
    }

}
